import { FileUpload } from "@mui/icons-material";
import { blue } from "@mui/material/colors";
import React, { useState } from "react";

import NoImage from "../../../assets/images/addimage.png"
import LoadingGif from "../../../assets/images/Spin_loader.gif"
import { Button } from "react-bootstrap";

import { ADD_PRODUCTS } from "../../AppConstant";
import axios from "axios";


function AddProductPage({setParentLoading}) {
    const [imagePreview, setImagePreview] = useState(NoImage);

    const [productName, setProductName] = useState("");
    const [productCount, setProductCount] = useState("");
    const [productFile, setProductFile] = useState(null);

    const [message, setMessage] = useState("");
    const [Errormessage, setErrorMessage] = useState("");

  

    const handleFileChange = (e) => {

    const file = e.target.files[0];

    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png"];

    if (!allowedTypes.includes(file.type)) {
        setErrorMessage("Only JPG, JPEG, PNG files are allowed");
        setProductFile(null);
        setImagePreview(NoImage);
        return;
    }

    const imageUrl = URL.createObjectURL(file);

    setErrorMessage("");
    setProductFile(file);
    setImagePreview(imageUrl);
};

    const BtnAddProducts = async (e) => {
        setParentLoading(true);
        e.preventDefault();

        if (!productName || !productFile || !productCount) {
            setErrorMessage("Please fill out all fields");
            setMessage("");
              setTimeout(() => {
            setParentLoading(false);
        }, 500);
            return;
        }

        const formData = new FormData();
        formData.append("name", productName);
        formData.append("count", productCount)
        formData.append("file", productFile);

        try {
            const response = await axios.post(
                ADD_PRODUCTS,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            setErrorMessage("");
            setMessage("Product added successfully");

            setProductName("");
            setProductCount("");
            setProductFile(null);
            setImagePreview(NoImage);

              setTimeout(() => {
            setParentLoading(false);
        }, 500);

        } catch (error) {
            
            console.error(error);

            if (error.response?.data?.error) {
                setErrorMessage(error.response.data.error);
            } else {
                setErrorMessage("Error adding product");
            }

            setMessage("")
              setTimeout(() => {
            setParentLoading(false);
        }, 500);
        }
    }



    return (
        <div>

            <div className="row">

                <div className="col-8">
                    <form action="" method="POST">
                        <div className="form-group">
                            <label for="name">Product Name</label>
                            <input type="text" className="form-control" name="name" id="productname" maxLength={70} value={productName} onChange={(e) => setProductName(e.target.value.toUpperCase())}></input>
                        </div>

                         <div className="form-group">
                            <label for="name">Product Count</label>
                            <input type="number" className="form-control" name="count" id="productcount" maxLength={3} value={productCount} onChange={(e) => setProductCount(e.target.value)}></input>
                        </div>

                        <div className="form-group">
                            <label for="name">Product Image</label>
                            <input type="file" className="form-control" name="file" id="productfile" key={productFile ? productFile.name : "no-file"} onChange={handleFileChange} accept=".jpg,.jpeg,.png,.jfif"></input>
                        </div>

                        <Button className="btn btn-success m-2" onClick={BtnAddProducts}>ADD</Button>

                        {message && (
                            <p style={{ color: "green", fontWeight: "bold" }}>
                                {message}
                            </p>
                        )}


                        {Errormessage && (
                            <p style={{ color: "red", fontWeight: "bold" }}>
                                {Errormessage}
                            </p>
                        )}


                    </form>
                </div>

                <div className="col-4">
                    <img
                        src={imagePreview}
                        alt="Preview"
                        style={{ width: "100%", objectFit: "contain", height: "150px" }}
                    />
                </div>
            </div>


         

        </div>

    )
}

export default AddProductPage;